exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::ng-deep .mat-dialog-container {\n  padding: 0 !important; }\n\n.mat-dialog-content {\n  margin: 0; }\n\n.full-width {\n  width: 100%; }\n\n.dialog-body {\n  padding: 16px; }\n\n.action-buttons {\n  margin-top: 50px;\n  float: right; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/app-root/src/src/app/components/admin/components/shared/petition-details/dialogs/executor-answer-dialog/executor-answer-dialog.component.scss
// module id = ../../../../../src/app/components/admin/components/shared/petition-details/dialogs/executor-answer-dialog/executor-answer-dialog.component.scss
// module chunks = main